import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {reactTableColumn} from '../../helpers/reactTable'
import CFXProReactTable from '../cfxProReactTable'
import {HEIFER_INDEX} from '../../constants'
import {deleteBackgrounder} from '../../actions'
import {withRouter} from 'react-router'
import api from '../../api'
import {syncObjectDelete} from '../../helpers/syncing'
import {actionButtons} from '../../helpers/button'

@withRouter
@connect((state) => {
  const {
    app: {isLoggedIn},
    userData: {backgrounders, userId},
  } = state

  return {
    isLoggedIn,
    backgrounders,
    userId,
  }
})
@api
class BackgrounderList extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      deletingId: null,
    }
  }

  localDeleteBackgrounder = (id) => {
    const {isLoggedIn, userId, apiInstance, dispatch} = this.props

    if (isLoggedIn) {
      this.setState({deletingId: id})
      syncObjectDelete(apiInstance, {userId, id}, dispatch, 'Backgrounder')
        .then((response) => {
          this.setState({deletingId: null})
        })
        .catch((err) => {
          this.setState({deletingId: null})
        })
    } else {
      dispatch(deleteBackgrounder(id))
    }
  }

  render() {
    const {backgrounders} = this.props
    const {deletingId} = this.state

    const data = Object.values(backgrounders)

    return (
      <div>
        <CFXProReactTable
          fixedHeaders={true}
          titleText="BACKGROUNDER"
          rightButtonIconName="fa-plus-circle"
          rightButtonCallback={() => {
            this.props.history.push('/breakeven/backgrounder/calculator')
          }}
          data={data}
          className="-striped -highlight"
          showPagination={data != null && data.length > 10}
          defaultPageSize={10}
          columns={[
            reactTableColumn('Scenario', 'purchaseWeight', '', (cell) => (
              <div className="cell-value">
                {cell.original.purchaseWeight}lb{' '}
                {cell.original.type === HEIFER_INDEX ? 'Heifer' : 'Steer'}
              </div>
            )),
            reactTableColumn('Purchase Date', 'purchaseDate'),
            reactTableColumn('Purchase $/lb', 'purchasePricePerLb'),
            reactTableColumn('Average Daily Gain', 'avgDailyGain'),
            reactTableColumn('Cost of Gain $/lb', 'costOfGain'),
            reactTableColumn('Sale Date', 'saleDate'),
            reactTableColumn('Sale Weight', 'saleWeight'),
            reactTableColumn('Expected Selling $', 'expectedSelling'),
            reactTableColumn('Sale Weight', 'saleWeight'),
            reactTableColumn('Total Cost', 'totalCost'),
            reactTableColumn('Total Revenue', 'totalRevenue'),
            reactTableColumn('Profit/Head', 'profitPerHead'),
            reactTableColumn('Actions', 'id', '', ({row}) => (
              <div className="cell-value">
                {actionButtons(
                  row,
                  deletingId,
                  '/breakeven/backgrounder/calculator/' + row.id,
                  this.localDeleteBackgrounder,
                )}
              </div>
            )),
          ]}
        />
      </div>
    )
  }
}

const BackgrounderItem = PropTypes.shape({
  id: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  purchaseweight: PropTypes.number.isRequired,
  purchaseDate: PropTypes.instanceOf(Date),
  purchasePricePerLb: PropTypes.number.isRequired,
  avgDailyGain: PropTypes.number.isRequired,
  costOfGain: PropTypes.number.isRequired,
  saleDate: PropTypes.instanceOf(Date),
})

BackgrounderList.propTypes = {
  data: PropTypes.arrayOf(BackgrounderItem),
}

export default BackgrounderList



// WEBPACK FOOTER //
// ./src/components/breakeven/backgrounderList.js